import React from "react";

export const symptons: string[] = [
  "Fever",

  "Fatigue",

  "Weight loss",

  "Weight gain",

  "Loss of appetite",

  "Night sweats",

  "Chills",

  "Weakness",

  "Malaise (general feeling of discomfort)",
  "Chest pain",

  "Palpitations",

  "Shortness of breath (dyspnea)",

  "Swelling in legs or ankles (edema)",

  "High blood pressure (hypertension)",

  "Low blood pressure (hypotension)",

  "Irregular heartbeat (arrhythmia)",

  "Dizziness or lightheadedness",
  'Cough (dry or productive)',

'Wheezing',

'Shortness of breath (dyspnea)',

'Chest tightness',

'Sputum production',

'Hemoptysis (coughing up blood)',



'Sneezing',

'Sore throat',
'Abdominal pain',

'Nausea',

'Vomiting',

'Diarrhea',

'Constipation',

'Bloating',

'Heartburn',
'Difficulty swallowing (dysphagia)',

'Blood in stool (hematochezia)',

'Black, tarry stools (melena)',

'Jaundice (yellowing of skin or eyes)',

'Loss of appetite',
"Headache",
"Migraine",
"Dizziness",
"Vertigo",
"Numbness or tingling",
"Seizures",
"Memory loss",
"Confusion",
"Difficulty speaking (dysarthria or aphasia)",
"Loss of consciousness",
"Tremors",
"Muscle weakness",

 // Musculoskeletal Symptoms
 "Joint pain",
 "Muscle pain (myalgia)",
 "Back pain",
 "Neck pain",
 "Swelling in joints",
 "Stiffness",
 "Limited range of motion",
 "Fractures or bone pain",

 // Dermatological Symptoms
 "Rash",
 "Itching (pruritus)",
 "Redness (erythema)",
 "Swelling (edema)",
 "Bruising",
 "Lesions or sores",
 "Dry skin",
 "Hair loss",
 "Changes in nail color or texture",

 // Urological Symptoms
 "Painful urination (dysuria)",
 "Frequent urination",
 "Blood in urine (hematuria)",
 "Urinary incontinence",
 "Difficulty starting urination",
 "Cloudy or foul-smelling urine",
 "Flank pain (kidney pain)",

 // Reproductive Symptoms
 "Pelvic pain",
 "Vaginal discharge",
 "Irregular menstrual cycles",
 "Heavy menstrual bleeding (menorrhagia)",
 "Pain during intercourse (dyspareunia)",
 "Erectile dysfunction",
 "Testicular pain or swelling",

 // Psychological Symptoms
 "Anxiety",
 "Depression",
 "Mood swings",
 "Insomnia",
 "Excessive sleepiness (hypersomnia)",
 "Irritability",
 "Hallucinations",
 "Suicidal thoughts",
 "Panic attacks",

 // Ophthalmological Symptoms
 "Blurred vision",
 "Double vision (diplopia)",
 "Eye pain",
 "Redness in eyes",
 "Dry eyes",
 "Excessive tearing",
 "Sensitivity to light (photophobia)",
 "Loss of vision",

 // ENT (Ear, Nose, Throat) Symptoms
 "Ear pain (otalgia)",
 "Hearing loss",
 "Tinnitus (ringing in ears)",
 "Sore throat",
 "Hoarseness",
 "Nasal congestion",
 "Sinus pain or pressure",
 "Difficulty swallowing (dysphagia)",

 // Endocrine Symptoms
 "Excessive thirst (polydipsia)",
 "Excessive urination (polyuria)",
 "Excessive hunger (polyphagia)",
 "Heat intolerance",
 "Cold intolerance",
 "Swelling in the neck (goiter)",
 "Changes in skin texture or color",

 // Hematological Symptoms
 "Easy bruising",
 "Prolonged bleeding",
 "Pale skin (pallor)",
 "Swollen lymph nodes",
 "Frequent infections",

 // Infectious Disease Symptoms
 "Fever",
 "Sore throat",
 "Cough",
 "Diarrhea",

 "Rash",
 "Swollen lymph nodes",
 "Body aches",

 // Allergic Symptoms
 "Itching (pruritus)",
 "Hives (urticaria)",
 "Swelling (angioedema)",

 "Runny nose",
 "Red, watery eyes",
 "Shortness of breath (due to anaphylaxis)",

 // Oncological Symptoms
 "Unexplained weight loss",
 "Persistent fatigue",
 "Lumps or masses",
 "Changes in moles or skin lesions",
 "Persistent pain",
 "Night sweats",
 "Unusual bleeding or discharge",

 // Pediatric Symptoms
 "Delayed growth or development",
 "Poor feeding",
 "Excessive crying",
 "Fever in infants",
 "Rashes",
 "Behavioral changes",

 // Geriatric Symptoms
 "Memory loss",
 "Falls or balance issues",
 "Urinary incontinence",
 "Chronic pain",
 "Depression or loneliness",

 // Additional Symptoms
 "Allergies (food, drug, environmental)",
 "Medication side effects",
 "Substance abuse symptoms",
 "Post-surgical symptoms",
 "Trauma-related symptoms"
];
